module.exports = __webpack_public_path__ + "static/img/express.615ae8b0.png";